import {
  Add01Icon,
  Archive03Icon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowLeft02Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  Attachment01Icon,
  BotIcon,
  FileEditIcon,
  LeftToRightListBulletIcon,
  Camera01Icon,
  Calendar03Icon,
  CancelIcon,
  CellsIcon,
  Chart03Icon,
  Chat01Icon,
  CheckmarkCircle02Icon,
  CircleIcon,
  CopyIcon,
  Clock04Icon,
  DashboardSquare01Icon,
  DeleteIcon,
  Doc01Icon,
  DriveIcon,
  Edit03Icon,
  Ellipsis,
  File01Icon,
  FileUploadIcon,
  FilterIcon,
  Folder01Icon,
  Folder02Icon,
  FolderLibraryIcon,
  FolderShared02Icon,
  GlobeIcon,
  HelpCircleIcon,
  HelpSquareIcon,
  ImageAdd02Icon,
  ImageIcon,
  LanguageSkillIcon,
  Link04Icon,
  LinkSquare02Icon,
  Loading02Icon,
  MagicWand05Icon,
  MapPinIcon,
  Mic02Icon,
  MentoringIcon,
  PanelLeftCloseIcon,
  PanelLeftOpenIcon,
  PlayCircleIcon,
  PrinterIcon,
  Projector01Icon,
  QrCodeIcon,
  ReloadIcon,
  RemoveSquareIcon,
  SentIcon,
  Robot01Icon,
  School01Icon,
  Search01Icon,
  Settings01Icon,
  Share01Icon,
  SparklesIcon,
  SquareLock02Icon,
  StopCircleIcon,
  Tick02Icon,
  TimeQuarter02Icon,
  Undo03Icon,
  User03Icon,
  UserGroupIcon,
  UserRemove02Icon,
  ViewIcon,
  ViewOffIcon,
  Watch01Icon,
  YoutubeIcon,
  FolderAddIcon,
} from '@hugeicons/core-free-icons';

/* eslint-disable @typescript-eslint/naming-convention */

type IconSvgObject =
  | [string, Record<string, string | number>][]
  | readonly (readonly [string, Readonly<Record<string, string | number>>])[];

// Central mapping of icon names to Hugeicons definitions. Extend here when adding new icons.
const Icons = {
  magic_wand: MagicWand05Icon,
  qr_code: QrCodeIcon,
  image: ImageIcon,
  eye_open: ViewIcon,
  eye_closed: ViewOffIcon,
  drive_file: DriveIcon,
  copy: CopyIcon,
  edit: Edit03Icon,
  delete: DeleteIcon,
  ellipsis: Ellipsis,
  left_panel_open: PanelLeftOpenIcon,
  left_panel_close: PanelLeftCloseIcon,
  folder: Folder01Icon,
  folder_open: Folder02Icon,
  plus: Add01Icon,
  circle: CircleIcon,
  watch: Watch01Icon,
  library: FolderLibraryIcon,
  cancel: CancelIcon,
  robot: Robot01Icon,
  people: UserGroupIcon,
  cog: Settings01Icon,
  file: File01Icon,
  chevron_up: ArrowUp01Icon,
  chevron_down: ArrowDown01Icon,
  chevron_left: ArrowLeft01Icon,
  chevron_right: ArrowRight01Icon,
  checkmark: Tick02Icon,
  attachment: Attachment01Icon,
  language: LanguageSkillIcon,
  search: Search01Icon,
  filter: FilterIcon,
  file_upload: FileUploadIcon,
  upload: FileUploadIcon,
  link: Link04Icon,
  youtube: YoutubeIcon,
  checkmark_circle: CheckmarkCircle02Icon,
  open_in_new: LinkSquare02Icon,
  question_mark_square: HelpSquareIcon,
  question_mark_circle: HelpCircleIcon,
  lock: SquareLock02Icon,
  share: Share01Icon,
  evaluate: Chart03Icon,
  back: ArrowLeft02Icon,
  print: PrinterIcon,
  loading: Loading02Icon,
  calendar: Calendar03Icon,
  camera: Camera01Icon,
  bot: BotIcon,
  share_folder: FolderShared02Icon,
  dashboard: DashboardSquare01Icon,
  speech_bubble: Chat01Icon,
  user: User03Icon,
  present: Projector01Icon,
  add_image: ImageAdd02Icon,
  sparkles: SparklesIcon,
  undo: Undo03Icon,
  country: GlobeIcon,
  state: MapPinIcon,
  school: School01Icon,
  subject: CellsIcon,
  docx: Doc01Icon,
  file_edit: FileEditIcon,
  list_bullet: LeftToRightListBulletIcon,
  play: PlayCircleIcon,
  reload: ReloadIcon,
  sent: SentIcon,
  history: Clock04Icon,
  duration: TimeQuarter02Icon,
  mic: Mic02Icon,
  stop: StopCircleIcon,
  remove_person: UserRemove02Icon,
  remove: RemoveSquareIcon,
  archive: Archive03Icon,
  create_folder: FolderAddIcon,
  // for template icons - remove once we switched to huge icons
  question_mark: HelpCircleIcon,
  webinar: MentoringIcon,
  //********
} as const;

export type Icon = keyof typeof Icons;

export type IconProps = {
  icon: Icon;
  size?: number;
  spin?: boolean;
};

export const resolveIcon = (icon: Icon): IconSvgObject => Icons[icon];

// Export list of available icon names for consumers (e.g., Storybook galleries)
export const iconNames = Object.keys(Icons) as Icon[];
